<!-- 专题视频-->
<template>
    <div class="special-sub-box" v-if="showSpecial">
        <div class="special-sub-bg"></div>
        <div class="special-sub-content">
            <div class="special-sub-title">专题片</div>
            <div class="special-sub-center">
                <div class="special-sub-item first" @click="showVideo('829d0322537d4a909c6f282f8d95c02a')"></div>
                <div class="special-sub-item second" @click="showVideo('108a76e8d4574aa4a8a6321d4ee1ed67')"></div>
            </div>
            <div class="special-sub-close" @click="handleClose"></div>
        </div>
        <videoHotspot class="special-sub-video"  v-if="videoShow"  @closeVideo="closeVideo" :guid="guid"></videoHotspot>
    </div>
</template>
  
<script>
 import videoHotspot from "@/components/phone/videoHotspot";
import { close_music, open_music } from "../../utils/audio";

export default {
    name: 'canwser',
    components: {
        videoHotspot
    },
    props:{
        showSpecial:false
    },
    data() {
        return {
            guid:"",
            videoShow:false,
            audioState:""
        }
    },
    methods: {
         handleClose(){
        
            this.$emit("closeSpecialSub")
         },
          // 关闭讲解视频事件
        closeVideo() {
       
            this.videoShow = false;
            open_music()
        },
        showVideo(guid) {
            this.guid = guid;
            this.videoShow = true;
            close_music()
        },
    },

}
</script>
  
<style lang="scss" scoped>
@mixin background-com {
    background-repeat: no-repeat;
    background-size: 100% 100%;
}
.special-sub-box{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000000;
  .special-sub-bg{
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.56);
    @include background-com();
    position: absolute;
    left: 0;
    top: 0;
  }
  .special-sub-content{
    width: 8.1rem;
    height: 13.33rem;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -6.667rem;
    margin-left: -4.05rem;
 
    .special-sub-title{
   
        height: 0.5rem;
        width: 100%;
        line-height: 0.5rem;
        position: absolute;
        top: -0.7rem;
     

        font-size: 0.54rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #FFFFFF;
 
    }
    .special-sub-center{
       @include background-com();
       background-image: url("~@/assets/img/phone/special-subject-bg.png");
       width: 100%;
       height: 100%;
       display: flex;
       flex-direction: column;
       align-items: center;
       justify-content: center;
       .special-sub-item{
        width: 6.49rem;
        height: 4.06rem;
        @include background-com();
        cursor: pointer;
        margin-bottom: 0.9rem;
         &.first{
            
            background-image: url("~@/assets/img/phone/fjxsd1.png");
         }
         &.second{
            background-image: url("~@/assets/img/phone/fjxsd2.png");
         }
       }
    }
    .special-sub-close{
        width: 0.76rem;
        height: 0.76rem;
        background: url('~@/assets/img/answer/answer-close-btn.png') no-repeat center;
        background-size: cover;
        position: absolute;
        top: -0.5rem;
        right: -0.78rem;
        cursor: pointer;
    }
  }
}
</style>